"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelFactory = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var FuelFactory = (function (_super) {
    __extends(FuelFactory, _super);
    function FuelFactory() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.FUEL_FACTORY,
            tags: [Tags_1.Tags.BUILDING],
            cost: 6,
            productionBox: Units_1.Units.of({ energy: -1, megacredits: 1, titanium: 1 }),
            metadata: {
                cardNumber: '180',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().energy(1).br;
                        pb.plus().titanium(1).megacredits(1);
                    });
                }),
                description: 'Decrease your Energy production 1 step and increase your titanium and your M€ production 1 step each.',
            },
        }) || this;
    }
    FuelFactory.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    };
    FuelFactory.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        return undefined;
    };
    return FuelFactory;
}(Card_1.Card));
exports.FuelFactory = FuelFactory;
